export function loopingPagerMod(value: number, modulus: number): number {
  return modulus > 0 ? ((value % modulus) + modulus) % modulus : 0;
}

/** Steps between two pages around the ring, in whichever direction is shorter. */
export function loopingPagerRingDistance(from: number, to: number, count: number): number {
  const forward = loopingPagerMod(to - from, count);
  return Math.min(forward, count - forward);
}

/**
 * The page one step from `index` around the ring: the page after the last is the first, and the
 * page before the first is the last.
 */
export function loopingPagerStep(index: number, step: 1 | -1, count: number): number {
  return loopingPagerMod(index + step, count);
}

/**
 * The direction a programmatic selection moves in: around the ring for a neighbour, otherwise
 * toward the side its tab is on.
 */
export function loopingPagerSelectionDirection(from: number, to: number, count: number): 1 | -1 {
  const forward = loopingPagerMod(to - from, count);
  if (forward === 1) {
    return 1;
  }
  if (forward === count - 1) {
    return -1;
  }
  return to > from ? 1 : -1;
}
